import { render, staticRenderFns } from "./UserOrderInfo.vue?vue&type=template&id=1cade466&scoped=true&"
import script from "./UserOrderInfo.vue?vue&type=script&lang=js&"
export * from "./UserOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cade466",
  null
  
)

export default component.exports